import { createSelector } from 'reselect'
import { IStore } from '../../reducers/index'

const sizeSelector = (state: IStore) => state.app.size
const pathSelector = (state: IStore) => state.app.config.assets_path || '/'

export default createSelector(sizeSelector, pathSelector, (size, path) => {
	return {
		path,
		size,
	}
})
